import { Component } from "react";
import Loader from "../../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import ExhibitorTopMenu from "../../../../../common_components/exhibitor_module_topmenu";
import { withRouter } from "../../../../../utils/withRouter";
import { connect } from "react-redux";
import {
  getExhibitorBadge_action,
  deleteExhibitorBadge_action,
  submitExhBadges_action,
} from "../../../../../actions/exhibitor_module_actions/manual_Forms_actions/forms_actions/exhibitor_badge_action/exhibitor_badge_action";
import {
  toastError,
  toastSuccess,
  countryActionId,
  cityActionId,
  stateActionId,
} from "../../../../../utils/constants";
import Modal from "react-modal";
import ExhibitorHeader from "../../../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../../../common_components/exhibitor_module_drawer";
import moment from "moment";
import ConfirmationModal from "../../../../../common_components/confirmationa_modal";


class ExhibitorBadge extends Component {
  // Initialize Constructor
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      exhibitorBadgesList: [],
      confirmationObj: { message: '', buttonName: '', action: '' },
      popArg: [],
      isOpenConfirmationModal: false,
      isDelOpen: false,
      exhibitorBadgeFormId: "",
      exBadgeListLength: "",
      DeadlineDate: "",
      currentDate: moment().format("DD-MM-YYYY"),
      MaxUnpaidBadge: "",
      unpaidArrayList: [],
      paidArrayList: [],
      StatusID: "",
      isShowExhibitorManualFormPaidBadge: "",
      is_View: false,
      isHideSection: sessionStorage.getItem("RoleIDSS") != 1 && sessionStorage.getItem("RoleIDSS") != 8,
    };
    this.getExhibitorBadgesList = this.getExhibitorBadgesList.bind(this);
    this.handleAdd = this.handleAdd.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.onUpdateClick = this.onUpdateClick.bind(this);
    this.toggleDelModal = this.toggleDelModal.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.submitExhBadges = this.submitExhBadges.bind(this);
    this.onViewClick = this.onViewClick.bind(this);
    this.handleConfirmation = this.handleConfirmation.bind(this)
  }


  handleConfirmation(flag) {
    const { confirmationObj, popArg } = this.state;
    if (flag) {
      if (confirmationObj.action == 0) {
        this.submitExhBadges()
      }
    }
    this.setState({ isOpenConfirmationModal: false })
  }


  componentDidMount() {
    this.setState({
      DeadlineDate:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.Deadline != ""
          ? moment(this.props.location.state.Deadline).format("DD-MM-YYYY")
          : "",

      StatusID:
        this.props.location.state != null && this.props.location.state.StatusID
          ? this.props.location.state.StatusID
          : "",
      is_View:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.is_View != null
          ? this.props.location.state.is_View
          : sessionStorage.getItem("RoleIDSS") != 1,
    });
    console.log("this.props", this.props);
    this.getExhibitorBadgesList();
  }

  // Get Exhibitor Badges
  getExhibitorBadgesList() {
    this.setState({ isLoading: true });
    this.props
      .getExhibitorBadge_action()
      .then((data) => {
        if (data.error != 1) {
          console.log("Exhibitor Badge Details", data.data);
          this.setState({
            MaxUnpaidBadge: data.maxUnpaidBadge[0]["MaxUnpaidBadge"],
            isShowExhibitorManualFormPaidBadge:
              data.maxUnpaidBadge[0]["isShowExhibitorManualFormPaidBadge"],
          });
          if (data.data != "") {
            const unpaidArray = [];
            const paidArray = [];
            data.data.map((item) => {
              if (!item.isPaid) {
                var filePath = item.VaccinationCertifcateFilePath;
                var array = item.VaccinationCertifcateFilePath != null && filePath.split("/");
                item.vaccFileName = array[array.length - 1];
                unpaidArray.push(item);
              } else {
                var filePath = item.VaccinationCertifcateFilePath;
                var array = item.VaccinationCertifcateFilePath != null && filePath.split("/");
                item.vaccFileName = array[array.length - 1];
                paidArray.push(item);
              }
            });
            this.setState({ unpaidArrayList: unpaidArray, paidArrayList: paidArray });
          }

          // setting unique doc No
          var docNo = data.data.length;
          this.setState({
            exhibitorBadgesList: data.data,
            isLoading: false,
            exBadgeListLength: docNo,
          });
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  // Handle Add
  handleAdd(value) {
    const { exBadgeListLength, StatusID, MaxUnpaidBadge, paidArrayList, unpaidArrayList } = this.state;
    const DeadlineDate = this.props.location.state?.DeadlineDate || null;
    const ActualDeadline = this.props.location.state?.ActualDeadline || null;
    const ManualFormsID = this.props.location.state?.ManualFormsID || null;
    const ServiceID = this.props.location.state?.ServiceID || null;
    const VendorDetails = this.props.location.state?.VendorDetails || {};
    if (value == "UnPaid") {
      this.props.navigate("/exhibitorbadgeAU", {
        state: {
          is_add: true,
          exBadgeListLength: exBadgeListLength,
          UnPaid: true,
          Deadline: DeadlineDate,
          ActualDeadline: ActualDeadline,
          ManualFormsID,
          ServiceID,
          VendorDetails,
          MaxUnpaidBadge: parseInt(MaxUnpaidBadge) - parseInt(unpaidArrayList.length)
        },
      });
    } else {
      this.props.navigate("/exhibitorbadgeAU", {
        state: {
          is_add: true,
          exBadgeListLength: exBadgeListLength,
          Paid: true,
          Deadline: DeadlineDate,
          ActualDeadline: ActualDeadline,
          ManualFormsID,
          ServiceID,
          VendorDetails,
          MaxUnpaidBadge: parseInt(MaxUnpaidBadge) - parseInt(unpaidArrayList.length)
        },
      });
    }
  }

  // Handle Back
  handleBack() {
    this.props.navigate("/manualForms");
  }

  // On Update Icon Click
  onUpdateClick(Id, value) {
    const { exBadgeListLength, StatusID } = this.state;
    const DeadlineDate = this.props.location.state?.DeadlineDate || null;
    const ActualDeadline = this.props.location.state?.ActualDeadline || null;
    const ManualFormsID = this.props.location.state?.ManualFormsID || null;
    const ServiceID = this.props.location.state?.ServiceID || null;
    const VendorDetails = this.props.location.state?.VendorDetails || {};
    this.props.navigate("/exhibitorbadgeAU", {
      state: {
        is_update: true,
        exhibitorBadgeFormId: Id,
        exBadgeListLength: exBadgeListLength,
        Deadline: DeadlineDate,
        ActualDeadline: ActualDeadline,
        StatusID: StatusID,
        UnPaid: value,
        ManualFormsID,
        ServiceID,
        VendorDetails,
      },
    });
  }

  // On View Click
  onViewClick(Id) {
    const { exBadgeListLength, StatusID } = this.state;
    const DeadlineDate = this.props.location.state?.DeadlineDate || null;
    const ActualDeadline = this.props.location.state?.ActualDeadline || null;
    const ManualFormsID = this.props.location.state?.ManualFormsID || null;
    const ServiceID = this.props.location.state?.ServiceID || null;
    const VendorDetails = this.props.location.state?.VendorDetails || {};
    this.props.navigate("/exhibitorbadgeAU", {
      state: {
        is_View: true,
        exhibitorBadgeFormId: Id,
        Deadline: DeadlineDate,
        ActualDeadline: ActualDeadline,
        StatusID: StatusID,
        ManualFormsID,
        ServiceID,
        VendorDetails,
      },
    });
  }

  // Delete Exhibitor Badge Modal Toggle
  toggleDelModal(id) {
    const { isDelOpen } = this.state;
    this.setState({ isDelOpen: !isDelOpen, exhibitorBadgeFormId: id });
  }

  // // handle Receipt Delete"
  handleDelete(e) {
    e.preventDefault();
    const { isDelOpen, exhibitorBadgeFormId } = this.state;
    this.setState({ isLoading: true });
    this.props
      .deleteExhibitorBadge_action(exhibitorBadgeFormId)
      .then((data) => {
        if (data.error != 1) {
          toastSuccess("Exhibitor Badge Deleted SuccessFully");
          this.setState({ isLoading: false, isDelOpen: !isDelOpen });
          this.getExhibitorBadgesList();
        } else {
          toastError(data.msg);
          this.setState({ isLoading: false });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  // On Submit Exhibitor Badges
  submitExhBadges() {
    this.setState({ isLoading: true });
    this.props
      .submitExhBadges_action()
      .then((data) => {
        if (data.error != 1) {
          this.setState({ isLoading: false });
          setTimeout(() => {
            this.props.navigate("/manualForms");
          }, 1000);
        } else {
          toastError(data.msg);
          this.setState({ isLoading: false });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  render() {
    const {
      isLoading,
      exhibitorBadgesList,
      isDelOpen,
      DeadlineDate,
      currentDate,
      MaxUnpaidBadge,
      unpaidArrayList,
      paidArrayList,
      StatusID,
      isShowExhibitorManualFormPaidBadge,
      isHideSection, RoleID, isOpenConfirmationModal
    } = this.state;
    const isDeadlinePassed =
      DeadlineDate &&
      moment(DeadlineDate, "DD-MM-YYYY").isValid() &&
      moment(currentDate, "DD-MM-YYYY").isAfter(moment(DeadlineDate, "DD-MM-YYYY"));

    return (
      <>
        {isOpenConfirmationModal ? <ConfirmationModal onConfirmation={this.handleConfirmation} message={this.state.confirmationObj} /> : null}
        {isLoading ? <Loader></Loader> : null}
        <ToastContainer />
        {!isHideSection && (
          <>
            <ExhibitorHeader />
            <ExhibitorDrawer />
          </>
        )}
        <div className="page">
          <div className="page-main exb-top-space">
            <div className={!isHideSection ? "with-dr-container" : ""} style={{ marginTop: RoleID == 1 ? "0px" : "" }}>
              <div className=" width-dr-nav">
                {!isHideSection && (
                  <div className="row">
                    <ExhibitorTopMenu />
                  </div>
                )}
              </div>
              <div className="row mt-4 m-0">
                <div className="col-xl-12">
                  <div className="card rounded-0 border p-0 mb-0">
                    <div className="card-header p-2">
                      <h3 className="card-title">Exhibitor Badges</h3>
                    </div>

                    {!isHideSection && <div className="row mt-1" style={{ paddingLeft: "1rem" }}>
                      <h6 className="mt-2 px-1 ">
                        <span className="text-danger">
                          {" "}
                          Last Date Of Submission -{" "}
                          {this.props.location?.state?.ActualDeadline
                            ? moment(this.props.location.state.ActualDeadline).format("DD-MM-YYYY")
                            : "-"}
                        </span>
                      </h6>
                    </div>}
                    <div className="card-body p-2">
                      <div className="row">
                        {currentDate > DeadlineDate && (
                          <span className="text-danger">
                            THE DEADLINE TO FILL OUT THE FORM HAS PASSED.
                          </span>
                        )}
                      </div>
                      <div className="table-responsive mt-1">
                        <div>
                          {!isHideSection && <button
                            className="btn btn-aqua mb-1"
                            type="btn"
                            style={{ float: "right", width: "60px" }}
                            disabled={
                              currentDate > DeadlineDate || unpaidArrayList.length == MaxUnpaidBadge
                            }
                            onClick={(e) => this.handleAdd("UnPaid")}
                          >
                            Add
                          </button>}
                          <p className="m-0">
                            Exhibitor UnPaid Badge{" "}
                            <span className="text-danger">
                              (You Can Only Add {MaxUnpaidBadge} UnPaid Badges)
                            </span>
                          </p>
                          <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                            <thead>
                              <tr>
                                <th className="text-center">Sr No.</th>
                                {/* <th>Images</th> */}
                                <th>Name</th>
                                <th>CATEGORY</th>
                                <th>DESIGNATION</th>
                                <th>COUNTRY</th>
                                <th>COMPANY NAME</th>
                                <th>REMARKS</th>
                                <th>Status</th>
                                <th className="text-center">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {unpaidArrayList.length > 0 ? (
                                unpaidArrayList.map((data, index) => (
                                  <tr>
                                    <td>{index + 1}</td>
                                    {/* <td>{data.vaccFileName}</td> */}
                                    <td>{data.Name}</td>
                                    <td>{data.ChapterNames}</td>
                                    <td>{data.Designation}</td>
                                    <td>{data.CountryName}</td>
                                    <td>{data.CompanyName}</td>
                                    <td>{data.Remarks || "-"}</td>
                                    <td>{data.Status}</td>
                                    <td className="text-center">
                                      {data.Status != "Approved" || currentDate > DeadlineDate ? (
                                        <span className="action-icon">
                                          <i
                                            className="fa fa-trash text-danger"
                                            aria-hidden="true"
                                            onClick={(e) =>
                                              this.toggleDelModal(data.ExhBadgesFormID)
                                            }
                                          />
                                        </span>
                                      ) : (
                                        <></>
                                      )}
                                      <span className="">
                                        {data.Status == "Approved" || currentDate > DeadlineDate ? (
                                          <i
                                            className="fa fa-eye text-info"
                                            aria-hidden="true"
                                            onClick={(e) => this.onViewClick(data.ExhBadgesFormID)}
                                          />
                                        ) : (
                                          <i
                                            className="fa fa-pencil text-info"
                                            aria-hidden="true"
                                            onClick={(e) =>
                                              this.onUpdateClick(data.ExhBadgesFormID, 1)
                                            }
                                          />
                                        )}
                                      </span>
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan={10} className="text-center">
                                    Record not available
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                        {isShowExhibitorManualFormPaidBadge &&
                          unpaidArrayList.length == MaxUnpaidBadge ? (
                          <div className="mt-6">
                            {!isHideSection && <button
                              className="btn btn-aqua mb-1"
                              type="btn"
                              style={{ float: "right", width: "60px" }}
                              disabled={currentDate > DeadlineDate}
                              onClick={(e) => this.handleAdd("Paid")}
                            >
                              Add
                            </button>}
                            <p className="m-0">Exhibitor Paid Badge</p>
                            <table className="table border text-nowrap text-md-nowrap table-bordered mb-0 ">
                              <thead>
                                <tr>
                                  <th className="text-center">Sr No.</th>
                                  {/* <th>Images</th> */}
                                  <th>Name</th>
                                  <th>CATEGORY</th>
                                  <th>DESIGNATION</th>
                                  <th>COUNTRY</th>
                                  <th>COMPANY NAME</th>
                                  <th>REMARKS</th>
                                  <th>Status</th>
                                  <th className="text-center">Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {paidArrayList.length > 0 ? (
                                  paidArrayList.map((data, index) => (
                                    <tr>
                                      <td>{index + 1}</td>
                                      {/* <td>{data.vaccFileName}</td> */}
                                      <td>{data.Name}</td>
                                      <td>{data.ChapterNames}</td>
                                      <td>{data.Designation}</td>
                                      <td>{data.CountryName}</td>
                                      <td>{data.CompanyName}</td>
                                      <td>{data.Remarks || "-"}</td>
                                      <td>{data.Status}</td>
                                      <td className="text-center">
                                        {data.Status != "Approved" || currentDate > DeadlineDate ? (
                                          <span className="action-icon">
                                            <i
                                              className="fa fa-trash text-danger"
                                              aria-hidden="true"
                                              onClick={(e) =>
                                                this.toggleDelModal(data.ExhBadgesFormID)
                                              }
                                            />
                                          </span>
                                        ) : (
                                          <></>
                                        )}
                                        <span className="">
                                          {data.Status == "Approved" ||
                                            currentDate > DeadlineDate ? (
                                            <i
                                              className="fa fa-eye text-info"
                                              aria-hidden="true"
                                              onClick={(e) =>
                                                this.onViewClick(data.ExhBadgesFormID)
                                              }
                                            />
                                          ) : (
                                            <i
                                              className="fa fa-pencil text-info"
                                              aria-hidden="true"
                                              onClick={(e) =>
                                                this.onUpdateClick(data.ExhBadgesFormID, 0)
                                              }
                                            />
                                          )}
                                        </span>
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td colSpan={10} className="text-center">
                                      Record not available
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        ) : (
                          <></>
                        )}

                      </div>
                    </div>
                  </div>

                  {!isHideSection && (
                    <div className="d-flex flex-wrap align-items-center justify-content-between mt-2 gap-2">

                      {/* Left: Note */}
                      <p className="m-0 text-nowrap">
                        <strong>Note:</strong>{" "}
                        <span className="text-danger">
                          All Exhibitors must carry Valid Photo Id &amp; Valid Vaccination
                          Certificate during {sessionStorage.getItem("sessionExhibitionName")}
                        </span>
                      </p>

                      {/* Right: Buttons */}
                      <div className="d-flex align-items-center gap-2">
                        {/* <button
                          type="button"
                          className="btn btn-aqua rounded-1"
                          disabled={currentDate > DeadlineDate}
                          onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: `Do you want to Submit?`, buttonName: "Submit", action: 0 }, popArg: [] })}>
                          Submit
                        </button> */}

                        <button
                          className="btn rounded-1 btn-gray m-2"
                          onClick={() => this.handleBack()}
                        >
                          Back
                        </button>
                      </div>

                    </div>
                  )}

                </div>
              </div>
              {/* <div class="footer-sec">
          <div class="sdsd">
              <strong>Ownership:</strong> All content, formats and images used on this site are owned or licensed by India ITME Society. You may not copy, reproduce, distribute, publish, display, perform, modify, create derivative works, transmit, or in any other way exploit any part of copyrighted material without permission of the copyright owner. Failure to comply shall result in legal action.
          </div>
      </div>

      <div class="footer-first">
          <div class="container-fluid">
              <div class="footer-first">  ITME All Rights Reserved <i class="fa fa-copyright" aria-hidden="true"></i> 2023  </div>
          </div>
      </div> */}
            </div>
          </div>
        </div>
        <Modal isOpen={isDelOpen} onRequestClose={() => this.setState({ isDelOpen: false })}>
          <div className="modal-dialog">
            <div className="modal-content confirm-logout">
              <div class="modal-header p-2">
                <h5 class="modal-title">Confirm Delete</h5>
                <button
                  type="button "
                  class="close pop-close"
                  data-dismiss="modal"
                  onClick={() => this.setState({ isDelOpen: false })}
                >
                  <span aria-hidden="true" class="pop-cancel">
                    &times;
                  </span>
                </button>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div class="col-md-12">
                    <p class="pop_label">Do you really want to delete this record?</p>
                  </div>
                </div>
              </div>
              <div class="modal-footer p-1">
                <div class="form-group text-right mod-fot">
                  <button
                    type="button"
                    class="btn btn-del-pop"
                    onClick={(e) => this.handleDelete(e)}
                  >
                    Yes
                  </button>
                  <button
                    type="button"
                    class="btn btn-gray"
                    data-dismiss="modal"
                    style={{ marginLeft: "5px" }}
                    onClick={() => this.setState({ isDelOpen: false })}
                  >
                    No
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </>
    );
  }
}

export default withRouter(
  connect(null, { getExhibitorBadge_action, deleteExhibitorBadge_action, submitExhBadges_action })(
    ExhibitorBadge
  )
);
